module.exports = __webpack_public_path__ + "img/arkel.d32bc978.png";